import parseJwt from '../parseJWT';
import getDiffInSeconds from '../getDiffInSeconds';

export default ({ signinData = {}, jwt = null }) => {
  let showConsentRequest = false;

  let consent = signinData?.formData?.consent;

  if (jwt) {
    const { user } = parseJwt(jwt) || {};
    if (
      user
      && user.consents
      && Object.keys(user.consents).length > 0
      && Object.keys(user.consents).includes('1')
    ) {
      consent = user.consents['1'];
    }
  }

  console.log({ loginTs: signinData?.lastSession?.loginTs });
  console.log({ loginTsIsNumber: !Number.isNaN(signinData?.lastSession?.loginTs) });

  if (!consent) {
    if (signinData?.lastSession?.loginTs && !Number.isNaN(signinData?.lastSession?.loginTs)) {
      console.log('compute time');
      const diffInSeconds = getDiffInSeconds(
        signinData.lastSession?.loginTs,
        signinData.lastSession?.loginTs.toString().length,
      );
      const daysSinceLastLogin = Math.floor(diffInSeconds / 86400000);
      if (daysSinceLastLogin >= 183) { // 182.5 === 6 mesi
        showConsentRequest = true;
      }
    } else if (
      !signinData?.lastSession?.loginTs
      || !Object.keys(signinData || {}).length
    ) { // se non abbiamo il record ls
      console.log('show');
      showConsentRequest = true;
    }
  }

  return showConsentRequest;
};
